module.exports = __webpack_public_path__ + "static/default-article-img-8d7fb65d8cd72f725cc4f8cc1293e428.png";